<template>
<div class='nedom'>
    <!-- <div v-for="(i,index) in tableData" :key="index"> -->
        <div class="Chartleftok" ref="wrap" style="height:350px" > </div>   
    <!-- </div> -->
</div>
</template>
<script>
export default {
    props:{
        oktype:{},
        BeginTime:{},
        EndTime:{},
        index:{},
    },
    data(){
        return {
            tableData:''
        }
    },
    watch:{
            oktype(newName, oldName){
                this.drawLineGrapg()
                console.log(newName)
            },
            BeginTime(newName, oldName){
                 this.drawLineGrapg()
            },
            EndTime(newName, oldName){
                this.drawLineGrapg()
            },
            // index(newName, oldName){
            //        this.drawLineGrapg(newName)
            // }
    },
    mounted(){
    this.drawLineGrapg()
    console.log(1)
    },
   methods:{
    drawLineGrapg(index){
        let option = {
            xAxis: {
                type: 'category',
                data: []
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: [],
                type: 'bar',
                showBackground: true,
                itemStyle: {
                    barBorderRadius: 5,
                    normal: {
                        //颜色随机改变
                        color: function (value){ 
                            return "#"+("00000"+((Math.random()*16777215+0.5)>>0).toString(16)).slice(-6);
                        }
                    }
                }
            }]
        }
                    let params=this.$fun.GetUserConstant()
                    params.BeginTime=this.BeginTime
                    params.EndTime=this.EndTime
                    params.Sort=this.oktype
                    console.log(params)
                    //    ;
                    this.$Api.GetOverallSalesAnalysis(params).then((res)=>{
                        console.log(res)
                            var arrname = [];
                            var obj = [];
                            for (var i = 0; i < res.data.length; i++) {
                                if (arrname.indexOf(res.data[i].Sort) == -1) {
                                    arrname.push(res.data[i].Sort);
                                }
                            }
                         for (var j = 0; j < arrname.length; j++) {
                                obj.push({
                                    data:[],
                                    newitem:[],
                                    nwdata:[]
                                })
        
                            res.data.forEach(function (item) {
                                    if (arrname[j] === item.Sort) {
                                        obj[j].data.push(item)
                                        obj[j].newitem.push(item.MC)
                                        obj[j].nwdata.push(item.XSJE)
                                    }
                                });
                            }
                            this.tableData=obj
                            console.log( this.tableData)
                        //      
                        let newDom=document.querySelector('.nedom')
                        //   
                        // newDom.innerHTML=''
                        // obj.forEach((item,index)=>{
                        //     console.log(item)
                        //     // newDom.innerHTML+=`<div class="Chartleftok"  ref="wrap" style="height:350px" >${{index}} </div>`
                        //     // let div=document.createElement('div')
                        //     // div.className="Chartleftok"
                        //     // div.style.height="350px"
                        //     // div.setAttribute('ref','wrap'+index)
                        //     // newDom.append(div)
                        //     option.xAxis.data = item.newitem
                        //     option.series[0].data = item.nwdata
                            
                        //     // let myChart = this.$echarts.init(this.$refs.wrap)
                        //     // myChart.setOption(option)
                        //     // let myChart = this.$echarts.init(this.$refs.wrap)
                        //     // myChart.setOption(option)
                        // })
                        console.log(this.index)
                            option.series[0].data = obj[this.index].nwdata
                             option.xAxis.data = obj[this.index].newitem
                        })
                        .then(()=>{
                            //   ;
                            let myChart = this.$echarts.init(this.$refs.wrap)
                            console.log(myChart)
                             myChart.setOption(option)
                            console.log(option)
                        
                        })
                        
                        
    }
   }





    //  props:['oktype'],
    //   data() {
    //      return {
    //      };
    //  },     
    //  watch:{
    //     'oktype'(x,l){
    //       this.drawLineGrapg()
    //     }
    //  },
    // mounted(){ 
    // },
    //  methods:{
    //         drawLineGrapg(){
    //           this.$nextTick(() => {    
    //            let option = {
    //               xAxis: {
    //                   type: 'category',
                
    //               },
    //               yAxis: {
    //                   type: 'value'
    //               },
    //               series: [{
    //                 data:[],
    //                   type: 'bar',
    //                     itemStyle: {
    //                         barBorderRadius: 5,
    //                         normal: {
    //                             //颜色随机改变
    //                             color: function (value){ 
    //                                 return "#"+("00000"+((Math.random()*16777215+0.5)>>0).toString(16)).slice(-6);
    //                             }
    //                         }
    //                     }
    //                 }],
    //             }
    //                  let params=this.$fun.GetUserConstant()
    //                 params.BeginTime=this.value1
    //                 params.EndTime=this.value2
    //                 params.Sort=this.oktype
    //                 console.log(params)
    //                 //   ;
    //                 this.$Api.GetOverallSalesAnalysis(params).then((res)=>{
    //                     console.log(res,params)
                         
    //                         var arrname = [];
    //                         var obj = [];
    //                         for (var i = 0; i < res.data.length; i++) {
    //                             if (arrname.indexOf(res.data[i].Sort) == -1) {
    //                                 arrname.push(res.data[i].Sort);
    //                             }
    //                         }
    //                      for (var j = 0; j < arrname.length; j++) {
    //                             obj.push({
    //                                 data:[],
    //                                 newitem:[],
    //                                 nwdata:[]
    //                             })
        
    //                         res.data.forEach(function (item) {
    //                                 if (arrname[j] === item.Sort) {
    //                                     obj[j].data.push(item)
    //                                     obj[j].newitem.push(item.MC)
    //                                     obj[j].nwdata.push(item.XSJE)
    //                                 }
    //                             });
    //                         }
    //                         //     ;
    //                          option.series[0].data = obj[0].nwdata
    //                             //   ;
    //                          this.btndata(option)
    //                     })
    //          })
             
    //         },
    //         btndata(){
    //                              let myChart = this.$echarts.init(this.$refs.wrap);
    //                             myChart.setOption(option);
    //                             window.addEventListener("resize", function () {
    //                              myChart.resize();
    //                                 })
    //         },
    //     }   
}
</script>